<template>
    <div class="p-14 flex flex-col items-center justify-center">
        <LetterWarningIcon color="#FF0000" class="mb-10"/>
        <p class="text-body-6 font-normal text-default-1 text-center"> Are you sure you want to delete the resource {{resource.resourceable.title}}?</p>
        <div class="flex flex-row mt-5 justify-between">
            <CoreButton buttonType="primary" label="Yes" size="default" @click="handleDelete" class="mr-4"
                        :loading="loading" :disabled="loading"/>
            <CoreButton buttonType="secondary" label="No" size="default" @click="$emit('close')"/>
        </div>

    </div>
</template>
<script setup>
import LetterWarningIcon from "@/components/icons/LetterWarning.vue";
import CoreButton from "@/components/core/Button.vue";
import {ref} from "vue";

const props = defineProps(['resource']);
const emit = defineEmits(['delete', 'close']);

const loading = ref(false);

function handleDelete() {
    loading.value = true;
    emit('delete');
}
</script>

